import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { referralApi } from "redux/referral/api";
import { setEnabled } from "redux/referral/slice";

const useReferralStatus = () => {
  const dispatch = useDispatch();
  const { data: isEnabled, refetch, isLoading } = referralApi.useEnabledQuery();

  useEffect(() => {
    if (isEnabled) {
      dispatch(setEnabled(isEnabled));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isEnabled]);

  return { refetch, isLoading };
};

export default useReferralStatus;
